const pages = {
  auth: {
    root: "auth",
    login: {
      name: "login",
      path: "/auth/login",
    },
    register: {
      name: "register",
      path: "/auth/register",
    },
  },
  home: {
    name: "home",
    // path: '/alerts-dashboard' //TODO: routing here because there is not a home page yet
    path: "/players-dashboard", // temp
  },
  health: {
    name: "health",
    path: "/health",
  },
  playersDashboard: {
    name: "players-dashboard",
    path: "/players-dashboard",
  },
  openTrades: {
    name: "open-trades",
    path: "/open-trades",
  },
  reports: {
    name: "reports",
    path: "/reports",
  },
  alertsDashboard: {
    name: "alerts-dashboard",
    path: "/alerts-dashboard",
  },
  rulesDashboard: {
    name: "rules-dashboard",
    path: "/rules-dashboard",
  },
  systemDashboard: {
    name: "system-dashboard",
    path: "/system-dashboard",
  },
  playerDetailDashboard: {
    name: "player-detail-dashboard",
    path: "/player-detail-dashboard/:playerId",
  },
  status: {
    root: "status",
    unverified: {
      name: "unverified",
      path: "/status/unverified",
    },
    statusComingSoon: {
      name: "coming-soon",
      path: "/status/coming-soon",
    },
    statusMaintenance: {
      name: "maintenance",
      path: "/status/maintenance",
    },
    status404: {
      name: "404",
      path: "/status/404",
    },
    status500: {
      name: "500",
      path: "/status/500",
    },
    statusSuccess: {
      name: "success",
      path: "/status/success",
    },
    statusFailure: {
      name: "failure",
      path: "/status/failure",
    },
    statusCancel: {
      name: "cancel",
      path: "/status/cancel",
    },
  },
  riskSettings: {
    name: "risk-settings",
    path: "/risk-settings",
  },
};

export default pages;
